module.exports = __webpack_public_path__ + "static/media/shuffle.8cb25cfb.png";